import React from 'react'

const SearchShimmer = () => {
    return (
        <>
            <div className="flex m-2.5">
                <div className="w-20 bg-[#f2f6fc] h-12 p-1 mr-4"></div>
                <div className="flex flex-1 flex-col justify-center">
                    <div className="w-40 h-2 bg-[#f2f6fc] m-1.5"></div>
                    <div className="w-16 h-2 bg-[#f2f6fc] m-1.5"></div>
                </div>
            </div>
            <div className="flex m-2.5">
                <div className="w-20 bg-[#f2f6fc] h-12 p-1 mr-4"></div>
                <div className="flex flex-1 flex-col justify-center">
                    <div className="w-40 h-2 bg-[#f2f6fc] m-1.5"></div>
                    <div className="w-16 h-2 bg-[#f2f6fc] m-1.5"></div>
                </div>
            </div>
            <div className="flex m-2.5">
                <div className="w-20 bg-[#f2f6fc] h-12 p-1 mr-4"></div>
                <div className="flex flex-1 flex-col justify-center">
                    <div className="w-40 h-2 bg-[#f2f6fc] m-1.5"></div>
                    <div className="w-16 h-2 bg-[#f2f6fc] m-1.5"></div>
                </div>
            </div>
            <div className="flex m-2.5">
                <div className="w-20 bg-[#f2f6fc] h-12 p-1 mr-4"></div>
                <div className="flex flex-1 flex-col justify-center">
                    <div className="w-40 h-2 bg-[#f2f6fc] m-1.5"></div>
                    <div className="w-16 h-2 bg-[#f2f6fc] m-1.5"></div>
                </div>
            </div>
        </>
    )
}

export default SearchShimmer